import { lazyRouteComponent } from "@tanstack/react-router";




const Dashboard = lazyRouteComponent(() => import("./dashboard.view"), "Dashboard");

export const routeOptions = {
  component: Dashboard,
  head: () => ({
    meta: [
      { title: "Min översikt – Alkoholprovet" },
      { name: "description", content: "Se din progress, dina svaga områden och tidigare svar." },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: "Min översikt – Alkoholprovet" },
      { property: "og:description", content: "Se dina framsteg, svaga områden och tidigare svar på Alkoholprovet." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
};
